import { useCallback, useEffect, useState } from "react";
import { Alert, Flex } from "antd";
import { observer } from "mobx-react-lite";

import { CustomButton } from "ui";
import { useStores } from "stores";
import { getContractAvailableLimit } from "services";
import { CONTRACT_STATUS_ENUM } from "interfaces";
import { SendBidModal } from "./SendBidModal";
import { isStatusIncluded } from "utils";

export const SendBidButton = observer(() => {
  const { actionModals, contractCard } = useStores();
  const { id, fiatAmount, status } = contractCard.card;

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [contractLimitAmount, setContractAvailableAmount] = useState<number>();

  const getAvailableLimit = useCallback(async (contractId: string) => {
    setError(null);
    setLoading(true);
    await getContractAvailableLimit({ id: contractId })
      .then((limit: number) => {
        setContractAvailableAmount(limit);
      })
      .catch((e) => {
        setError(e.title);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!!fiatAmount) {
      getAvailableLimit(id);
    }
  }, [fiatAmount, getAvailableLimit, id]);

  const sendBidHandler = () => {
    actionModals.open(() => <SendBidModal data={contractCard.card} contractLimitAmount={contractLimitAmount} />, {
      width: "750px",
      noValidation: true,
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };

  const isBlockedContract = isStatusIncluded(status, [CONTRACT_STATUS_ENUM.BLOCKED]);
  const tooltip = isBlockedContract
    ? "Создание заявки недоступно для заблокированного договора"
    : contractLimitAmount === 0
      ? "Лимит договора исчерпан"
      : undefined;

  return (
    <Flex vertical gap="middle">
      <CustomButton
        id="contract-create-bid-button"
        onClick={sendBidHandler}
        loading={loading}
        disabled={loading || !!error || contractLimitAmount === 0 || isBlockedContract}
        tooltip={tooltip}
      >
        Создать заявку
      </CustomButton>

      {error && <Alert message={"Ошибка"} description={error} type={"error"} showIcon />}
    </Flex>
  );
});
